import { Text, TextLink } from '@mattilsynet/mt-ui';
import React from 'react';
interface IAdresseErrorProps {
  refetch: () => void;
}
export const AdresseError = ({
  refetch
}: IAdresseErrorProps) => <>
    <Text margin={[0, 0, 1, 0]} data-sentry-element="Text" data-sentry-source-file="AdresseError.tsx">
      Kunne ikke hente adresse og overordnet org nr
    </Text>
    <TextLink onClick={refetch} data-sentry-element="TextLink" data-sentry-source-file="AdresseError.tsx">Last innhold på nytt</TextLink>
  </>;